module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='/* ==========================================================================\n    Pendragon Perspective styles\n    User styles generated via PREFS page\n    For default values, property should be left undeclared\n    ========================================================================== */\n\n/* 2. Text size \n------------------------------------------------------ */\n/* This sets the base font size for the document pane. Default 15px. \nAll document font sizes are relative to this, using EM units in doc.less */\n.pane-toc .inner {\n    font-size: '+
((__t=( text_size ))==null?'':_.escape(__t))+
'px;\n}';
}
return __p;
};
